<template>
  <SearchContainer>
    <template slot="default">
      <div class="input-row">
        <div class="">
          <Input
              type="text"
              :label="$t('sections.ords.chargingCurvesSearch.cpe')"
              :field="query.cpe"
              @input="(e) => onInput('cpe', e)"
          />
        </div>
        <div class="select-month">
          <Input
              type="monthpicker"
              :label="$t('sections.ords.chargingCurvesSearch.month')"
              :field="query.monthYear"
              format="MM/yyyy"
              valueFormat="MM-yyyy"
              @input="(e) => onInput('monthYear', e)"
          />
        </div>
      </div>
    </template>
  </SearchContainer>
</template>

<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'ChargingCurvesSearchOptions',
  components: {
    SearchContainer,
    Input,
  },
  data() {
    return {
      query: {
        cpe: '',
        monthYear: '',
      },
    };
  },
  methods: {
    onInput(field, value) {
      this.query[field] = value;

      this.$emit('onSearchInput', this.query);
    },
  },
};
</script>
<style lang="scss" scoped>
.options-container {
  --input-label-width: 102px;
}

.select-month {
  display: flex;
  align-items: center;

  :deep(.el-input__inner) {
    height: 46px;
    padding-left: 48px;
  }

  :deep(.el-input__icon) {
    display: flex;
    align-items: center;
    padding-left: 12px;
  }
}

.input-row {
  display: flex;
  gap: 20px;
}
</style>
